import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { routes } from "./routes";
import { QueryClientProvider } from "react-query";
import { persistor, store } from "./store";
import { Provider } from "react-redux";
import Layout from "partials/layout";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import Modal from "./components/modal";
import { queryClient } from "services/queryClient";
import "react-toastify/dist/ReactToastify.css";
import HomeLayout from "components/dashboard/layouts/HomeLayout";
import Home from "pages/students/studentdashboard/pages/Home/Home";
import MyCourses from "pages/students/studentdashboard/pages/myCourses/MyCourses";
import MyTraining from "pages/students/studentdashboard/pages/myTrainings/MyTraining";
import MockTest from "pages/students/studentdashboard/pages/MockTest";
import Counsellor from "pages/students/studentdashboard/pages/Counsellor";
import Events from "pages/students/studentdashboard/pages/Events/Events";
import Settings from "pages/students/studentdashboard/pages/Settings";
import Support from "pages/students/studentdashboard/pages/Profile";
import DiscoverAllCourses from "pages/students/studentdashboard/pages/myCourses/AllCourses";
import CourseDetails from "pages/students/studentdashboard/pages/myCourses/courseDetails/CourseDetails";
import { EventDetails } from "pages/students/studentdashboard/pages/Events/EventDetails";
import { MockDetails } from "pages/students/studentdashboard/pages/mockTest/MockDetails";
import Exam from "pages/students/studentdashboard/pages/mockTest/Exam";
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <ToastContainer />
            <Modal />
            <Routes>
              {routes.map((route) => {
                const layout = route.layout;
                const path = route.path;
                const Component = layout ? (
                  <Layout>{route.Component}</Layout>
                ) : (
                  route.Component
                );
                return <Route path={path} element={Component} key={path} />;
              })}
              <Route path="dashboard" element={<HomeLayout />}>
                {/* Nested Routes inside Dashboard */}
                <Route path="home" element={<Home />} />
                <Route path="my-courses" element={<MyCourses />} />
                <Route path="my-training" element={<MyTraining />} />
                <Route path="mock-test" element={<MockTest />} />
                <Route path="counsellor" element={<Counsellor />} />
                <Route path="events" element={<Events />} />
                <Route path="Support" element={<Support />} />
                <Route path="settings" element={<Settings />} />
                <Route path="my-courses/discover-all" element={<DiscoverAllCourses />} />
                <Route path="my-courses/course-details" element={<CourseDetails />} />
                <Route path="events/event-details" element={<EventDetails />} />
                <Route path="mock-test/mock-details" element={<MockDetails />} />
                <Route path="mock-test/mock-details/exam" element={<Exam />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
